<template>
<!-- 나를 추천인으로 한 유저 리스트 -->  
    
    <!-- 추천인 적립 보상 기록 -->
    <section>
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <div class="tbl_wrap" v-else>            
            <table class="tbl">
                <colgroup>
                    <col style="*" />                    
                    <col style="width:30%" />
                    <col style="width:30%" />
                </colgroup>
                <thead>
                    <tr>                         
                        <th class="txt-left">나를 추천인으로 등록한 유저</th>
                        <th>등록일</th>
                        <th>최근로그인</th>                        
                    </tr>
                </thead>   
                <tbody>
                    <template v-if="recommenderLists.data.length ===0">
                        <tr><td colspan="3">내역이 없습니다.</td></tr>                    
                    </template>
                    <template v-else>
                        <tr v-for="(list, index) in recommenderLists.data" :key="index">                         
                            <td class="article_writer">
                                <user-name-tag
                                    :user="list.user"
                                    :displaymytalk="false"
                                    :displayProfileImage="true"
                                    />              
                            </td>                          
                            <td><display-time :time="list.created_at"/></td>                                               
                            <td></td>
                        </tr>                       
                    </template>
                   
                </tbody>     
            </table>        
        </div>
       
    </section>
</template>
<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'

import { auth } from '@/components/mixins/auth.js';
import { mapGetters } from 'vuex';
export default {
    name: 'myChildList',
    data () {
      return {
       
        isLoading:true,        
      }
    },   
    components: {     
      DisplayTime
    }, 
    mixins:[ auth ],
    mounted(){
        this.getRecommender();
    },
    computed:mapGetters({
        recommenderLists:'friend/getRecommender'
    }), 
    methods:{  
        async getRecommender(pagenumber,type){
            const formData = {
                user_id:this.user.id,
                page:pagenumber?pagenumber:1,
                type:type,                
            }
            const response = await this.$store.dispatch("friend/getRecommenderList", formData);
            console.log(response);

            this.isLoading= false;
            this.isLoadMore = false;
            if(this.lastPage <= this.page)
            {
                //alert('더이상 데이터가 없습니다.');
                this.moreData = false;
            }
        },
      
    },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
.searchDate{
    padding:20px;
    display:flex;
    justify-content: center;
    .input-group{
        width:300px;         
        input{
            border: 1px solid #ccc;            
            text-align: center !important;
        }   
    }
}
.listSum{
    background:#000;
    td{
        color:#fff !important;
        strong{
            color:aqua;
        }
    }    
}
</style>